<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseRequest.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('purchaseRequest.pageTitle'),
          href: '/admin/purchase-requests'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList v-model="model" :validate="errors" class="ts-border ts-rounded" />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                <ts-button @click.prevent="$router.push({ name: 'purchase-request' })">{{ $t('cancel') }}</ts-button>
                <ts-button :waiting="loading" @click.prevent="onUpdate" color="primary">{{ $t('update') }}</ts-button>
              </div>
            </div>
          </form>
          <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
            <ts-preview-pdf v-model="loading" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/info.vue'
import ItemList from './components/item-list'

export default {
  name: 'purchaseRequestV2Edit',
  components: {
    Info,
    ItemList
  },
  data() {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        pr_date: moment().format('DD-MM-YYYY'),
        pr_by: null,
        required_date: null,
        project_id: null,
        customer_id: null,
        remarks: null,
        details: []
      }
    }
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['edit_data'])
  },
  methods: {
    ...mapActions('purchaseRequest/purchaseRequest', [
      'getFormViewModel',
      'find',
      'update'
    ]),
    async getPreData({ params, index }) {
      this.loading = true
      this.getFormViewModel({ index: index, params: params })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .then(async () => {
          await this.find(this.$route.params.id).then(() => {
            this.setEditData()
          })
        })
        .finally(() => (this.loading = false))
    },
    onUpdate() {
      this.loading = true
      this.show_pdf = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    setEditData() {
      this.model.pr_date = this.edit_data.pr_date
      this.model.pr_by = this.edit_data.pr_by
      this.model.required_date = this.edit_data.required_date
      this.model.project_id = this.edit_data.project_id
      this.model.customer_id = this.edit_data.customer_id
      this.model.remarks = this.edit_data.remarks
      this.model.details = this.edit_data.details.map(el => ({
        pr_main_id: el.pr_main_id,
        pr_detail_id: el.pr_detail_id,
        product_id: el.product_id,
        uom_id: el.uom_id,
        uom_cat_id: el.unite_of_measure ? el.unite_of_measure.uom_cat_id : null,
        quantity: el.quantity ? el.quantity : 1,
        maximum_reorder_allow: el.product.maximum_reorder_allow
          ? el.product.maximum_reorder_allow
          : 0,
        alloworder: el.quantity >
          (el.product.maximum_reorder_allow
            ? el.product.maximum_reorder_allow
            : 0),
        input_currency_id: el.input_currency_id,
        currency_id: el.currency_id,
        fx_rate: el.fx_rate,
        fx_rate_ratio: el.fx_rate_ratio,
        input_unit_price: el.input_unit_price,
        unit_price: el.unit_price,
        input_total: el.input_total,
        total: el.total,
        remarks: el.remarks,
        order: el.order,
      }))
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseRequest/purchaseRequest/SET_EDIT_DATA', {})
    next()
  }
}
</script>
